import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { ElevatorAnimationPresentation } from './ElevatorAnimationPresentation.js';

var ElevatorAnimationWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(ElevatorAnimationWrapper, _React$Component);

  var _super = _createSuper(ElevatorAnimationWrapper);

  function ElevatorAnimationWrapper(props) {
    var _this;

    _classCallCheck(this, ElevatorAnimationWrapper);

    _this = _super.call(this, props);
    _this.observer = null;

    _this.handleVisibilityChange = function () {
      _this.setState({
        isVisible: true
      });
    };

    _this.state = {
      isVisible: false
    };
    return _this;
  }

  _createClass(ElevatorAnimationWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var options = {
        root: null,
        threshold: 0.9,
        rootMargin: "0px"
      };
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.isIntersecting && _this2.handleVisibilityChange();
        });
      }, options);
      this.observer.observe(this.target);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.observer.unobserve(this.target);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var children = this.props.children;
      var isVisible = this.state.isVisible;
      return /*#__PURE__*/React.createElement(ElevatorAnimationPresentation, Object.assign({}, this.props, {
        isVisible: isVisible,
        hostRef: function hostRef(_hostRef) {
          // this.setState({ target: hostRef });
          _this3.target = _hostRef;
        }
      }), children);
    }
  }]);

  return ElevatorAnimationWrapper;
}(React.Component);

export { ElevatorAnimationWrapper };
